import React from "react"
import PropTypes from "prop-types"
import { defineMessages } from "react-intl"
import { countries } from "countries-list"
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { formsAction } from "../../i18n/lstrings"
import useSmartFormat from "../../i18n/useSmartFormat"
import FlagIcon from "../FlagIcon"

const useStyle = makeStyles((theme) => ({
  countrySelector: {
    width: "100%",
    maxHeight: theme.spacing(50)
  },
  flagIcon: {
    marginRight: theme.spacing(2)
  }
}))

const messages = defineMessages({
  formElementCountryEmptyLabel: {
    id: "form.elements.country.empty",
    defaultMessage: "Select a country",
    description: "Country Form Element : Render Empty label"
  }
})

export default function CountrySelect(props) {
  const { input, className } = props
  const classes = useStyle()
  const format = useSmartFormat()
  const defaultSelectString = format(formsAction.defaultFormSelectLabel)

  const renderValue = (countryKey) => {
    if (!countryKey) {
      return (
        <Typography>{format(messages.formElementCountryEmptyLabel)}</Typography>
      )
    }
    const currCountry = countries[countryKey]
    return (
      <Box display="flex">
        <FlagIcon
          className={classes.flagIcon}
          code={countryKey.toLowerCase()}
        />
        <Typography>{currCountry.name}</Typography>
      </Box>
    )
  }
  return (
    <FormControl variant="outlined" size="small" className={className}>
      <Select {...input}>
        <MenuItem value="" disabled>
          {defaultSelectString}
        </MenuItem>
        {Object.keys(countries).map((countryKey) => {
          return (
            <MenuItem key={countryKey} value={countryKey}>
              {renderValue(countryKey)}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

CountrySelect.propTypes = {
  input: PropTypes.any.isRequired,
  className: PropTypes.object.isRequired
}
